import { render, staticRenderFns } from "./PaperPriceTable.vue?vue&type=template&id=17f3b3ee&"
import script from "./PaperPriceTable.ts?vue&type=script&lang=js&"
export * from "./PaperPriceTable.ts?vue&type=script&lang=js&"
import style0 from "./PaperPriceTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports